import { createGlobalStyle, css } from "styled-components";

const GlobalStyle = createGlobalStyle`
    @media print {
        tfoot {display: table-footer-group;}
        @page {
            size: auto;
            margin: 20mm 20mm 10mm 20mm;
        }
    }
    html {
        background-color: ${(props: any) => props.theme.colors.primary(1)};
        @media print {
            background-color: ${(props: any) => props.theme.colors.white(1)};
        }
    }
    body {
        font-weight: 100;
        padding-top: 4.5rem;
        font-family: 'Roboto', sans-serif;
        font-size: 16px;
        min-height: 100vh;
        background-color: ${(props: any) => props.theme.colors.white(1, 0.1)};
        @media print {
            padding-top: 0;
            background-color: ${(props: any) => props.theme.colors.white(1)};
        }
    }
    * {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    p {
        margin: 0;
    }
    #root {
        min-height: calc(100vh - 4.5rem);
        @media print {
            min-height: 0;
        }
    }
    ${(props) => {
        return css`
            @font-face {
                font-family: "goal-icons";
                src: url(${(props) => props.theme.staticPath + "static/fonts/goal-icons.ttf?jrwkxu"}) format("truetype"),
                    url(${(props) => props.theme.staticPath + "static/fonts/goal-icons.woff?jrwkxu"}) format("woff"),
                    url(${(props) => props.theme.staticPath + "static/fonts/goal-icons.svg?jrwkxu#goal-icons"}) format("svg");
                font-weight: normal;
                font-style: normal;
                font-display: block;
            }
        `;
    }}
`;

export default GlobalStyle;
